<template>
	<div class="variable-selector">
		<h4 class="var-title ellipsis" :title="title" v-if="title">{{title}}</h4>
		<div class="variable-search-filter">
			<input class="variables-search-input" :placeholder="$t('search')+'...'" v-model.trim="filter" @input="onFilterChange(filter)" ref="searchInput" />
			<!-- <custom-input
				ref="searchinput"
				@input="onFilterChange(filter)" 
				class="variables-search-input"
				v-model.trim="filter"
				:inputType="'text'"
				:name="'variableSearchInput'"
				:label="$t('var-selector.var-ph')"
				:placeholder="$t('search')"
				:autoComplete="'off'"
			/> -->
			<div @click="onEraseFilter(filter)" v-show="eraser"><i  class="close-icon fas fa-times"></i></div>
			<div class="search-icon">
				<i class="fa-light fa-search"></i>
			</div>
		</div>
		<div v-if="showConstantInput" class="constant-input">
			<input :class="{error: constantError}" type="text" v-model="constantValue" @input="$emit('constant-changed', constantValue)" :placeholder="$t('var-selector.input-ph')" />
		</div>
	
			<div class="variable-list-wrapper custom-scrollbar-light">
				<variable-group
					:group="variableGroups"
					:selected-variable-name="selectedVariableName" 
					:filter="filter"
					:show-values="true"
					:groupsOnly="groupsOnly"
					:variableTypeFilters="variableTypeFilters"
					@variable-selected="variableName => $emit('variable-name-changed', variableName)"
					@current-path="getPath"
					:showValueOnHover="showValueOnHover"
				/>
			</div>
		
	</div>
	
</template>

<script>
	import VariableGroup from '@/components/VariableGroup'
	import EventBus from '@/assets/js/eventBus.js'
	export default {
		props: {
			variableGroups: {
				type: Object,
				required: true
			},
			selectedVariableName: {
				type: String
			},
			showConstantInput: {
				type: Boolean,
				default: false
			},
			constant: {
				type: String,
				default: null
			},
			constantError: {
				type: Boolean
			},
			showValues: Boolean,
			title: String,
			backdrop: Boolean,
			groupsOnly:{
				type: Boolean,
				default: false
			},
			variableTypeFilters: Array,
			focusInputField: {
				type: Boolean,
				default: true
			},
			showValueOnHover: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				filter: '',
				eraser: false,
				selected: '',
				constantValue: ''
			}
		},
		computed: {
			path(){
				this.variableGroups.groups
				
				return 0
			}
		},
		methods: {
            focusSearch() {
                this.$nextTick(function () {
                    if(this.$refs.searchInput) this.$refs.searchInput.focus();
                });
            },
			getPath(){
				console.log("hellooo")
			},
			onEraseFilter(filter){
			console.log(filter)
			this.filter = ''
			filter = ''
			this.onFilterChange(filter)
		},
			onFilterChange (filter) {
			console.log(filter)
			if(this.filter == ''){this.eraser = false}
			if(this.filter != ''){this.eraser = true}
		},
		},
		watch: {
			constant: {
				immediate: true,
				handler (value) {
					if (value != null) {						
						this.constantValue = value
					} else this.constantValue = ''
				}
			}
		},
		components: {
			VariableGroup
		},
		mounted() {
			if(this.focusInputField){
				this.focusSearch();
			}
		},
			created(){
		EventBus.$emit('close_preview');
	},
	destroyed(){
		EventBus.$emit('open_preview');
		}
	}
</script>

<style lang="less">
	.variable-selector {
		color: var(--charcoal);
		background: var(--background-white);
		min-width: 250px;
		// height: 250px;
		// max-height: 350px;
		.variable-search-filter {
			position: relative;
			// margin: 0 12px 12px 12px;
			margin: 10px 15px ;
			.fa-times{
				position: absolute;
				right: 16px;
				top: 7px;
				width: 13px;
			}
		}
		// .variables-search-input {
		// 	padding: 0 10px;
		// 	border: 0 none;
		// 	// border-bottom: 1px solid #ccc;
		// 	&::placeholder {
		// 		color: var(--charcoal-50);
		// 	}
		// 	&:focus, &:active {
		// 		// border: none;
		// 		outline: none;
		// 	}
		// }
			.variables-search-input {
			padding: 5px 5px 5px 20px;
			width: 100%;
			border: 0 none;
			border-bottom: 1px solid #ccc;
			padding: 5px;
			
			&::placeholder {
				color: var(--charcoal-50);
			}

			&:focus, &:active {
				// border: none;
				outline: none;
			}
		}


		.constant-input {
			padding: 0 20px 10px 20px;
			input {
				padding: 5px 0;
				border: 0 none;
				width: 100%;
				border-bottom: 1px solid #F1F1F1;
				&::placeholder {
					color: #8F979C;
				}

				&:focus, &:active {
					outline: none;
				}
				&.error {
					border-bottom-color: #cd4b3d;
				}
			}
		}
	.search-icon, .searching {
      position: absolute;
      right: 10px;
      bottom: 7px;
      width: 13px;
	}
	.searching{
		bottom: 12px;
	}

		.var-title {
			color: var(--charcoal);			
			margin-bottom: 0;
		}
		.variable-list-wrapper {
			overflow: auto;
			max-height: 170px;
		}

		.no-border {
			border: 0 none;
		}
	
	}
</style>
